import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize AOS (Animate On Scroll)
AOS.init({
  duration: 800,
  easing: 'ease-in-out',
  once: false,
  offset: 100,
  delay: 0,
  anchorPlacement: 'top-bottom',
});